import { on } from '@ember/modifier';
import { t } from 'ember-intl';
import pageTitle from 'ember-page-title/helpers/page-title';
import transitionTo from 'ember-router-helpers/helpers/transition-to';
import Button from 'tio-reimagined/components/button';

<template>
  {{pageTitle (t "not_found.page_title")}}
  <div class="p-10 pt-12 grid justify-items-center place-content-center">
    <h1 class="text-2xl justify-center">
      {{t "not_found.headline"}}
    </h1>
    <p class="py-4">
      {{t "not_found.text"}}
    </p>
    <Button {{on "click" (transitionTo "authenticated.dashboard")}} class="w-48">
      {{t "not_found.button_text"}}
    </Button>
  </div>
</template>
